import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';

const InfoComponent = () => {
  return (
    <Container maxWidth={'lg'}>
      <Grid container style={{ padding: '100px 0' }}>
        <Grid
          item
          md={6}
          xs={12}
          style={{
            padding: '12px',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography variant="h4">
            Nossa tecnologia <br /> transformando a educação <br /> em números
          </Typography>
        </Grid>

        <Grid item md={6} xs={12}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                width: '100%',
                height: '100%',
                color: 'white',
                backgroundColor: '#002866',
                padding: '24px'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="h6"
                    style={{ textAlign: 'center', fontSize: '30px' }}
                  >
                    Correção ENEM e <br />
                    ENCCEJA 2018 - 2022
                  </Typography>

                  <Typography
                    variant="h6"
                    style={{ textAlign: 'center', fontSize: '30px', marginTop: '24px' }}
                  >
                    +24 milhões de <br />
                    redações corrigidas
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ borderTop: '1px solid white', paddingTop: '20px' }}
                >
                  <Typography
                    variant="h5"
                    style={{ textAlign: 'center', fontSize: '2rem' }}
                  >
                    +850.000 alunos
                  </Typography>
                  <Typography
                    style={{
                      marginTop: '10px',
                      color: 'white',
                      textAlign: 'center'
                    }}
                  >
                    Utilizam nossos sistemas de <br /> avaliação em larga escala
                    e ensino <br />
                    adaptativo.
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    borderTop: '1px solid white',
                    paddingTop: '5px',
                    marginTop: '20px'
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{ textAlign: 'center', fontSize: '2rem' }}
                  >
                    +30.000 professores
                  </Typography>
                  <Typography
                    style={{
                      marginTop: '10px',
                      color: 'white',
                      textAlign: 'center'
                    }}
                  >
                    Utilizam nossos sistemas de criação <br /> de questões,
                    avaliações/atividades e <br />
                    professor assistente.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default InfoComponent;
